'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _keyPaths = require('../constants/keyPaths');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _keyPaths.TYPE, null), _defineProperty(_Record, 'contactDeletion', false), _defineProperty(_Record, 'filtered', false), _defineProperty(_Record, 'agentId', null), _Record), 'FilteredChangeInfo');
module.exports = exports['default'];